import React from 'react';
import PropTypes from 'prop-types';
import BomCheck from './BomCheck';

class BomCheckModal extends React.Component {
    render() {
        return (
            <BomCheck
                isModal={true}
                open={this.props.open}
                onClose={this.props.onClose}
                assemblyId={this.props.assemblyId}
                onComplete={this.props.onComplete}
            />
        );
    }
}

BomCheckModal.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    assemblyId: PropTypes.string.isRequired,
    onComplete: PropTypes.func.isRequired
};

export default BomCheckModal; 